export default __webpack_public_path__ + "static/media/step_C_EN.86432330.png";